module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/koji-ecb7c1f390014e584a8c5c8d26cf6e58.webp";